module.exports = __webpack_public_path__ + "media/images/brand/new_stuff_letter/lab_door_x1-88a8efdc1f4e2be219950ebf1f5ebb80.jpg";